import React, { Component } from 'react';
import { Col, Row } from 'reactstrap';
import { FormattedMessage } from 'react-intl';
import { getReasonOptions } from '../Base/Common/ReferenceDataFunctions';

export class PaymentRefundsMobile extends Component {

    render() {
        const { reservationPaymentRefund } = this.props;
        
        return (
            <>
                {reservationPaymentRefund.map((el, k) => 
                    <Row className="mt-1" key={k}>
                        <Col className='col-6 d-flex flex-column mb-3'>
                            <h6>
                                <FormattedMessage id="Payments.Date"/>
                            </h6>
                            {el.createdAt}
                        </Col>
                        <Col className='col-6 d-flex flex-column mb-3'>
                            <h6>
                                <FormattedMessage id="Payments.Name"/>
                            </h6>
                            
                            {el.userName}
                        </Col>
                        <Col className='col-6 d-flex flex-column mb-3'>
                            <h6>
                                <FormattedMessage id="Payments.Amount"/>
                            </h6>
                            {el.amount}
                        </Col>
                        <Col className='col-6 d-flex flex-column mb-3'>
                            <h6>
                                <FormattedMessage id="Payments.Reason"/>
                            </h6>
                            {getReasonOptions().filter(reason => reason.value === el.reason).map(reason => reason.label)}
                        </Col>
                        <Col className='col-12 d-flex flex-column mb-3'>
                            <h6>
                                <FormattedMessage id="Payments.Notes"/>
                            </h6>
                            {el.notes}
                        </Col>
                    </Row>
                )}
            </>
        );
    }
}